import React, {Component} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button, Checkbox, Form, Icon, Input} from "semantic-ui-react";
import Lbl from "../../../../components/Label/Lbl";
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import * as EmailValidator from "email-validator";
import * as common from "../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import axios_tag from "../../../../axios/axios_tag";
import $ from "jquery";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import IntlTelInput from "react-intl-tel-input";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    email: "",
    name: "",
    username: "",
    id: "",
    valid_mobile: false,
    mobile: "",
    mobile_: "",
    password: "",
    added_by: "",
    added_date: "",
    modify_by: "",
    modify_date: "",
    validatePassword: false,
    validEmail: false,
    status: true,
  };

// ----------------------------- [function - handle changing of inputs | note: used] -----------------------------------

  handleChange = (name, length) => event => {
    let value = event.target.value;

    if (name === "password") {
      /*
      * Regex "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{9,}$)"
      * This regex pattern checks if a string contains at
      * least one lowercase letter,
      * one uppercase letter,
      * one numeric digit,
      * and one special character from the set [!@#$%^&*],
      * and is at least 9 characters long.
      * */
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else if (name === "email") {
      // Check email validity
      let validateEmail = EmailValidator.validate(value.trim());
      if (validateEmail) {
        this.setState({
          validEmail: true,
          [name]: value
        });
      } else {
        this.setState({
          validEmail: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };
  dropDownChange = name => (event, {value}) => {
    this.setState({
      selected_list: value
    })
  };

  //change phone number handler
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    // Mobile number formatting
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      mobile_: withdialcode,
      mobile: value
    });
  };

// ----------------------------------------- [function - modify Organizer] ---------------------------------------------

  modifyOrganizer = () => {

    let condition = false;
    let correct = false;
    // validation and show error notifications - name, username, email, mobile number
    this.state.name.trim() === '' ? common.notifyMessage("Please enter full name") :
      this.state.username.trim() === "" ? common.notifyMessage("Please enter username") :
        !this.state.validEmail ? common.notifyMessage("Please enter valid email") :
        !this.state.valid_mobile ? common.notifyMessage("Please enter valid mobile number") :
            condition = true;

    // if above conditions are passed, will check password validity
    if(condition){
      if(this.state.isPassword){
        if(!this.state.validatePassword){
          common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS")
        }else{
          correct = true;
        }
      }else{
        correct = true;
      }
    }

    // Show confirmation alert of organizer updating
    if(correct){
      swal({
        title: "Are you sure you want to modify the details",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            // send request to backend
            this.sendToBackend();
            break;
          default:
            // close the alert automatically
            break;
        }
      });
    }

  };

// --------------------------- [function - send to backend to data for update organizer] --------------------------------

  sendToBackend = () => {

    // get corporate id
    let coperateId = this.props.usr_obj.corporates[0].corporateId;

    // prepare request body
    const obj = {
      branches: [],
      corporates: [coperateId],
      userId:this.state.id,
      fullName: this.state.name,
      userName: this.state.username,
      email: this.state.email,
      mobile: this.state.mobile_,
      password: this.state.password,
      userRoles: "CORP_EVENT_ORGANIZER",
      status: this.state.status ? 1 : 0,
    };

    this.props.spinnerHandler(true); // start spinner loading

    // prepare request headers
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    // call the request - Update organizer
    axios_tag.post(apiConfig.CORPORATE_SYSTEM_USERS, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Organizer successfully updated - (" + this.state.username + ")", 0);
          this.props.closeModal();
          this.props.refreshData();
          this.props.addUpdate();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

// ------------------------------- [function - use for view password | note: used] -------------------------------------

  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

// ------------------------- [function - use for fill data into branch pool | note: used] ------------------------------
  fillData = () => {
    const {data} = this.props;
      this.setState({
        email: data.email,
        name: data.fullName,
        username: data.userName,
        mobile: data.mobile ? data.mobile : "",
        format_mobile: data.mobile ? data.mobile : "",
        valid_mobile: data.mobile ? true : false,
        password: data.password,
        id: data.userId,
        status: data.status === 1,
        validEmail: true
      })
  };

  toggle = () => {};

// --------------------------------------------- [ componentDidMount ] -------------------------------------------------

  componentDidMount() {
    this.fillData();
    $('input').attr('autocomplete', 'off'); // off fields auto completing
  }

// --------------------------------------------- [ render & return ] ---------------------------------------------------

  render(){
    return(
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Modify Organizer</MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Full Name</Lbl>
                        <LabelInput
                          placeholder={"Full Name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>User Name</Lbl>
                        <LabelInput
                          placeholder={"User Name"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />
                      </Col>

                      <Col lg="12" md={"12"} sm={"12"} xs={"12"} style={{marginTop:'14px', marginBottom: '14px', paddingLeft: '0px', paddingRight: '0px'}}>
                        <Lbl required style={{marginTop:'0px!important'}}>Event Organizer Mobile</Lbl>
                        <IntlTelInput
                          type={"text"}
                          fieldName={"Mobile Number"}
                          style ={{width:'100%', height:'37px'}}
                          value={this.state.mobile}
                          containerClassName="intl-tel-input dashboard-intl"
                          inputClassName="form-control"
                          onPhoneNumberChange={this.onPhoneNumberChange}
                          required={true}
                          preferredCountries={['lk']}
                          defaultCountry={"lk"}
                          nationalMode={false}
                          // customPlaceholder={this.customPlaceholder}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Email</Lbl>
                        <LabelInput
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Col>

                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>

                      <br/>

                      <Col className={"none-padding"} lg={12}>
                        <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                  checked={this.state.isPassword}
                                  onChange={() => this.setState({isPassword: !this.state.isPassword,password:"",validatePassword:false})} toggle
                                  label='Do you want to change Organizer password'/>

                        {
                          this.state.isPassword ?
                            <div>
                              <Lbl required>Password</Lbl>
                              <Input id={"password-field"} type={"password"}
                                     onChange={this.handleChange('password')}
                                     value={this.state.password}
                                     style={{width: '100%'}}
                                     icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                                 onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                                     placeholder='Password'/>
                            </div>
                            : null
                        }
                      </Col>
                      <br/>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.status} onChange={() => this.setState({status: !this.state.status})}
                                toggle
                                label={this.state.status ? 'Active' : 'Inactive'}/>
                      <br/>
                    </Form>

                    <center>
                      <Col lg={"12"} className={"marginTop"} style={{marginBottom: '5px'}}>
                        <Button className="px-5" onClick={this.modifyOrganizer}>Update Organizer</Button>
                      </Col>
                    </center>

                  </Col>
                </Row>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }

}

// get values from redux store
const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers,
  // usr obj
  usr_obj: state.userReducer.user,
});

// save/update redux store
const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
